/**
 * XML → JSON Tool
 */

import { XMLParser } from 'fast-xml-parser';

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

export const XmlToJsonTool: ITransformerTool = {
  id: 'xml-to-json',
  name: 'XML → JSON',
  description: 'Convert XML to JSON',
  version: '1.0.0',
  type: 'transformer',
  category: 'Converters',
  keywords: ['xml', 'json', 'convert', 'transform'],

  supportedInputTypes: [SEMANTIC_TYPES.XML, SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.JSON,

  attributes: [
    {
      name: 'pretty',
      type: 'boolean',
      label: 'Pretty Print',
      defaultValue: true,
      description: 'Pretty-print the JSON output',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    const text = String(input ?? '').trim();
    const pretty = config.pretty !== false;

    try {
      const parser = new XMLParser({
        ignoreAttributes: false,
        attributeNamePrefix: '@_',
        textNodeName: '#text',
        allowBooleanAttributes: true,
        parseTagValue: true,
        parseAttributeValue: true,
        trimValues: true,
      });

      const parsed = parser.parse(text);
      return pretty ? JSON.stringify(parsed, null, 2) : JSON.stringify(parsed);
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'Invalid XML';
      throw ToolError.validation(`Invalid XML: ${msg}`);
    }
  },
};
